import { useMemo } from 'react';

export const STUDY_RELEVANCE = Object.freeze({
  All: 'All',
  Study: 'Study',
  Global: 'Global',
});

export type TStudyRelevance = (typeof STUDY_RELEVANCE)[keyof typeof STUDY_RELEVANCE];

// The API interprets the string "null" to mean not belonging to any study.
const globalId = 'null';

/**
 * Hook that generates the correct array of [ID!] to pass to the graphql
 * templates or macros query "procedures" argument.
 */
export const useStudyRelevance = (
  relevance: TStudyRelevance,
  procedureSmid: string
): Array<string> => {
  return useMemo(() => {
    if (relevance === STUDY_RELEVANCE.Study) return [procedureSmid];
    if (relevance === STUDY_RELEVANCE.Global) return [globalId];
    // if neither of the above, don't filter by scope at all
    return [];
  }, [relevance, procedureSmid]);
};
